import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonService } from 'src/app/services/common/common.service';
import { StorageService } from 'src/app/services/storage/storage.service';
import { environment } from 'src/environments/environment';

@Component({
	selector: 'app-ai-activity-template',
	templateUrl: './ai-activity-template.component.html',
	styleUrls: ['./ai-activity-template.component.scss']
})
export class AiActivityTemplateComponent implements OnInit {
	@Input() data: any;

	@Output() aiActivityDataUpdated = new EventEmitter<any>();

	base_url: any = environment.apiEndpoint + "/";

	user_details: any;
	user_role: any = "";

	constructor(
		private storageService: StorageService,
		public commonService: CommonService,
		private datePipe: DatePipe
	) { }

	ngOnInit(): void {
		this.user_details = this.storageService.get("user_details");

		if (this.user_details.role.role == 3) {
			this.user_role = "Executive";
		} else if (this.user_details.role.role == 4) {
			this.user_role = "Advisor Manager";
		} else if (this.user_details.role.role == 5) {
			this.user_role = "Advisor";
		} else if (this.user_details.role.role == 6) {
			this.user_role = "AFA";
		} else if (this.user_details.role.role == 7) {
			this.user_role = "Assistant";
		} else if (this.user_details.role.role == 8) {
			this.user_role = "Relationship Manager";
		} else if (this.user_details.role.role == 10) {
			this.user_role = "Leadership";
		} else if (this.user_details.role.role == 11) {
			this.user_role = "Marketing Team";
		} else if (this.user_details.role.role == 12) {
			this.user_role = "Wholesaler";
		} else if (this.user_details.role.role == 13) {
			this.user_role = "Lending Officer";
		} else if (this.user_details.role.role == 14) {
			this.user_role = "Insurance Agent";
		}

		this.getActivityData();

	}

	close() {
		this.aiActivityDataUpdated.emit({ type: "Closed" });
	}

	activity_data: any = {};
	activity_data_copy: any = {};
	activity_data_loaded: boolean = false;
	ai_summary: any;
	predicted_segment_summary: any;
	getActivityData() {
		this.activity_data_loaded = false;
		let route: any = "";
		if (this.user_role == "Wholesaler") {
			route = "/wholesalerai/" + this.data.id + "/";
		} else if (this.user_role == "Leadership") {
			route = "/recruiterai/" + this.data.id + "/";
		}


		this.commonService.getData(route).subscribe(
			(res: any) => {
				this.activity_data = res;
				this.ai_summary =this.activity_data['ai_summary']
				this.predicted_segment_summary =this.activity_data['predicted_segment_summary']
				this.activity_data_loaded = true;
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	getValue(data, key) {
		if (data.type == "text") {
			if (this.activity_data[key] != "" && this.activity_data[key] != null) {
				return this.activity_data[key];
			} else {
				return "-";
			}
		} else if (data.type == "boolean") {
			if (this.activity_data[key] && this.activity_data[key] == true) {
				return "Yes";
			} else {
				return "No";
			}
		} else if (data.type == "date") {
			if (this.activity_data[key] != "" && this.activity_data[key] != null) {
				return this.datePipe.transform(this.activity_data[key], 'dd MMM yyyy');
			} else {
				return "-";
			}
		} else if (data.type == "year") {
			if (this.activity_data[key] != "" && this.activity_data[key] != null) {
				return this.datePipe.transform(this.activity_data[key], 'yyyy');
			} else {
				return "-";
			}
		} else if (data.type == "number") {
			if (this.activity_data[key] != "" && this.activity_data[key] != null) {
				return this.commonService.abbreviateNumber(this.activity_data[key]);
			} else {
				return "-";
			}
		} else if (data.type == "array") {
			if (this.activity_data[key].length > 0) {
				let value: any = this.activity_data[key].length;
				value = value +  "(";
				for (let index = 0; index < this.activity_data[key].length; index++) {
					value =  value  + this.activity_data[key][index];
					if ((index + 1) != this.activity_data[key].length) {
						value = value +  ", "
					}
				}
				value = value +  ")";
				return value;
			} else {
				return "0";
			}
		}
	}

	abbreviateNumber(value) {
		let fixed = 1;
		let num = value;
		if (num === null) {
		  return null;
		}
		if (num === 0) {
		  return '0';
		}
		fixed = !fixed || fixed < 0 ? 0 : fixed;
		var b = num.toPrecision(2).split('e'),
		  k = b.length === 1 ? 0 : Math.floor(Math.min(b[1].slice(1), 14) / 3), // floor at decimals, ceiling at trillions
		  c =
			k < 1
			  ? num.toFixed(0 + fixed)
			  : (num / Math.pow(10, k * 3)).toFixed(1 + fixed),
		  d = c < 0 ? c : Math.abs(c),
		  e = d + ['', 'K', 'M', 'B', 'T'][k];
		return e;

		// value = Math.round(value);
		// let new_value = value;
		// if (value >= 1000) {
		//     const suffixes = ["", "K", "M", "B","T"];
		//     const suffixNum = Math.floor( (""+value).length/3 );
		//     let shortValue: any = '';
		//     for (var precision = 2; precision >= 1; precision--) {
		//         shortValue = parseFloat( (suffixNum != 0 ? (value / Math.pow(1000,suffixNum) ) : value).toPrecision(precision));
		//         var dotLessShortValue = (shortValue + '').replace(/[^a-zA-Z 0-9]+/g,'');
		//         if (dotLessShortValue.length <= 2) { break; }
		//     }
		//     if (shortValue % 1 != 0)  shortValue = shortValue.toFixed(1);
		//     new_value = shortValue+suffixes[suffixNum];
		// }
		// return new_value;
	}

	navigateToExternalLink(link) {
		if (link != "" && link != null) {
			window.open(link, "_blank");
		}
	}

	experience_fields_data: any = [
		{
			name: "Experience/Qualification",
			fields: [
				{
					name: "Age (Years)",
					key: "age",
					type: "text"
				},
        {
					name: "Total Experience (Years)",
					key: "total_experience",
					type: "text"
				},
				{
					name: "States Registered",
					key: "registered_states",
					// type: "array"
					type: "text"
				},
				{
					name: "No. of Licences",
					key: "licenses",
					// type: "array"
					type: "text"
				},
				{
					name: "No. of Certificates",
					key: "total_certificates",
					type: "text"
				},
				{
					name: "Dually Licensed",
					key: "dually_licensed_bd_ria_rep",
					type: "boolean"
				},
				{
					name: "Dually Registered",
					key: "dually_registered_bd_ria_rep",
					type: "boolean"
				},
				{
					name: "Regulatory Disclosures",
					key: "regulatory_disclosures",
					type: "boolean"
				},
				{
					name: "Year became Representative",
					key: "date_became_rep_year",
					type: "text"
				},
        		{
					name: "Current Firm Experience (Years)",
					key: "experience_at_current_firm",
					type: "text"
				},
				{
					name: "Sells Insurance Products",
					key: "insurance_licensed",
					type: "boolean"
				},
				{
					name: "Sells Retirement Products",
					key: "sells_retirement_plan_products",
					type: "boolean"
				},
				{
					name: "Sells Series6 Mutual Funds",
					key: "series6_mutual_funds_and_variable_annuities",
					type: "boolean"
				},
        {
					name: "Miles to Work",
					key: "miles_to_work",
					type: "text"
				},
			]
		},
	];

	firm_profile_fields_data: any = [
		{
			name: "Firm Profile",
			fields: [
				{
					name: "Total AUM / production estimates",
					key: "total_opportunity",
					type: "number"
				},
				{
					name: "Number of Branches",
					key: "branches_count",
					type: "number"
				},
				{
					name: "Number of Advisors",
					key: "advisor_count",
					type: "number"
				},
				{
					name: "Channel Type",
					key: "channel_type",
					type: "text"
				},
				{
					name: "Product mix trends",
					key: "products_list",
					type: "array"
				},
				{
					name: "Hierarchy Info",
					key: "firm_type",
					type: "text"
				},
			]
		},
		{
			name: "Branch Profile",
			fields: [
				{
					name: "Estimated Branch AUM / Production",
					key: "total_branch_opportunity",
					type: "number"
				},
				{
					name: "Number of Advisors",
					key: "branch_advisor_count",
					type: "number"
				},
				{
					name: "Series Licensed Advisors",
					key: "series_advisor_count",
					type: "number"
				},
				{
					name: "Insurance Licensed Advisors",
					key: "insurance_advisor_count",
					type: "number"
				},
				{
					name: "Retirement Licensed Advisors",
					key: "retirement_advisor_count",
					type: "number"
				},
				{
					name: "Solo Reps",
					key: "solo_advisors",
					type: "number"
				},
				{
					name: "Multi Advisor Teams",
					key: "multi_advisors",
					type: "number"
				},
				{
					name: "Average Advisor Age",
					key: "avg_advisor_age",
					type: "text"
				},
				{
					name: "Average advisor Tenure",
					key: "avg_advisor_tenure",
					type: "text"
				},
				{
					name: "Geographic Location",
					key: "territory",
					type: "text"
				},
			]
		},
	];



}
